import { dateFn } from './filter'
export interface BaseResponse {
    result: number;
    error_msg?: string;
    msg?: string;
    error?: number;
}

export const buttonList = [
    {
        text: '昨天',
        value: dateFn(-1),
    },
    {
        text: '近7天',
        value: dateFn(-6),
    },
    {
        text: '近30天',
        value: dateFn(-29),
    }
]

export const tabListData = [
    {
        dashboardName: "总览",
        dashboardCode: "coreInfoOverview" // 从数图平台获取
    },
    {
        dashboardName: "收入分析",
        dashboardCode: "incomeAnalysis"
    },
    {
        dashboardName: "留存分析",
        dashboardCode: "retentionAnalysis" // 从数图平台获取
    },
    {
        dashboardName: "来源分析",
        dashboardCode: "originAnalysis" // 从数图平台获取
    }
]

export interface tabItemType {
    dashboardName: string;
    dashboardCode: string;
}


// 类型定义
// project-response
export interface ProjectType {
    dashboards: DashboardsType[]
}

export interface DashboardsType {
    conditions: ConditionsType[],
    dashboardCode: string,
    dashboardName: string,
    panels: PanelsType[]
}

export interface ConditionsType {
    compareType: string,
    defaultValue: string,
    displayName: string,
    fieldName: string,
    fieldType: string,
    options: OptionsType[],
    paramGroup: string,
    referCode: string,
    showPosition: string,
    valueType: string
}

export interface OptionsType {
    name: string,
    value: string
}

export interface PanelsType {
    charts: ChartsType[],
    conditions: ConditionsType[],
    panelId: number,
    panelName: string,
    panelPosition: string,
    panelTips: string,
    panelType: string,
    panels: PanelsType[]
}

export interface ChartsType {
    chartCode: string,
    chartId: number,
    chartName: string,
    chartSetting: string,
    chartTips: string,
    conditions: ConditionsType[],
    dimensions: DimensionsType[],
    limit: number,
    requestId: string,
    selectors: SelectorsType[],
    supportExport: boolean
}

export interface DimensionsType {
    fieldName: string,
    displayName: string,
    defaultSelect: number
}

export interface SelectorsType {
    fieldName: string,
    displayName: string,
    columnTips: string,
    scene: string,
    urn: string,
    axisType: string,
    valueType: string,
    defaultSelect: number,
    sortType: string,
    fixed: boolean,
    columnGroup: string,
    displayType: string,
    columnType: string,
    showCondition: string,
    displaySetting: string,
    propertyType: string
}

// chart-data
export interface ChartType {
    chartId: number,
    chartName: string,
    chartType: string,
    limit: number,
    offset: number,
    records: any,
    titles: TitlesType[]
}

// 折线图类型的
export interface ChartLineDataType {
    chartId: number,
    chartName: string,
    chartType: string,
    limit: number,
    offset: number,
    records: ChartLineRecordType[],
    titles: TitlesType[]
}

// card 类型
export interface ChartCardDataType {
    chartId: number,
    chartName: string,
    chartType: string,
    limit: number,
    offset: number,
    records: ChartDataCardRecordType[],
    titles: TitlesType[]
}

export type ChartLineRecordType = Record<string, string>
export interface TitlesType {
    fieldName: string,
    displayName: string,
    columnTips: string,
    scene: string,
    urn: string,
    axisType: string,
    valueType: string,
    sortType: string,
    fixed: boolean,
    columnGroup: string,
    displayType: string,
    columnType: string,
    showCondition: string,
    displaySetting: string,
    propertyType: string,
    show: boolean
}

// card 类型的chart records 的type类型
export interface ChartDataCardRecord {
    field_name: string;
    link_rate_title: string;
    link_rate_value: string;
    title: string;
    value: string;
}

export type ChartDataCardRecordType = Record<string, string> | ChartDataCardRecord;

export interface ResponseProject extends BaseResponse {
    data: ProjectType
}

export interface ResponseDashboardDetail extends BaseResponse {
    data: DashboardsType
}

export interface ResponseChartData extends BaseResponse {
    data: ChartLineDataType
}

export interface ResponseBatchChartData extends BaseResponse {
    data: ChartLineDataType[]
}

export interface ChartDataParamsType {
    chartId: string | number;
    selector: string[]; // 需要查询的字段
    conditions: ConditionsType[]; // 筛选条件
    granularity: string;
    sorts: []; // 暂时用不到 为[]
    limit?: number;
    offset: number;
}

export interface BatchChartDataParamsType {
    appId: string;
    dataRequests: ChartDataParamsType[]
}

// 新组合好的config(根据chart里selectors的displaySetting字段拆分，拆出符合条件的 selectors)
export interface NewSelectorConfigType extends ChartsType {
    needSelectorsfieldName: string[]
}

// 指标详情（批量）—— 新组合好的config(按照指标里的chartSetting划分的, 拆出符合条件的chart)
export interface NewChartListConfigType {
    needChartIds: number[],
    chartList: ChartsType[]
}

// 查询条件的type
export interface FilterFormItemType {
    fieldName: string;
    fieldValue: number | string;
}

export interface GameListItemType {
    appId: string;
    desc: string;
    gameTypeId: number;
    gameTypeName: string;
    icon: string;
    name: string;
    realizationWay: string; // 游戏变现类型中文含义
    realizationWayCode: string; // 游戏变现类型code :iaa/iap/iaap
}
